export default __webpack_public_path__ + "maps-examples-camera-animation-1200-f109b019834f00c0199df126e3fef0cc.png";